import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Thin banner that only renders while the browser reports offline.
 * Sits above the main header. Notifications still flow through the WS;
 * reads render from the persisted TanStack cache.
 */
export function OfflineBanner(): React.ReactElement | null {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' && navigator.onLine === false,
  );
  useEffect(() => {
    const on = (): void => setOffline(false);
    const off = (): void => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  if (!offline) return null;
  return (
    <div
      role="status"
      style={{
        background: 'var(--sl-warning-bg, #6b4200)',
        color: 'var(--sl-warning-text, #fff8dc)',
        borderBottom: '1px solid var(--sl-warning, #daa520)',
        padding: '6px 12px',
        fontSize: 12,
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 899,
        display: 'inline-flex',
        gap: 6,
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <WifiOff size={12} /> Offline - showing cached data. New changes will sync when you're back online.
    </div>
  );
}
